import { useEffect, useState } from 'react';

import { useLayoutStore } from '@/stores/layout/layout.store';
import { getPostsCategories } from '@/utils/contentfulPosts';

import type { TypeCategoriesSkeleton } from '@/@types/contentful';
import type { Entry } from 'contentful';

export type Category = Entry<TypeCategoriesSkeleton, undefined, string>;

const usePostsCategories = () => {
  const [categories, setCategories] = useState<Category[]>([]);
  const [isLoading, setLoading] = useState(true);
  const actualCountry = useLayoutStore((state) => state.country);

  const getCategories = async () => {
    setLoading(true);
    const response = await getPostsCategories();
    setCategories(response.items);
    setLoading(false);
  };

  useEffect(() => {
    if (actualCountry !== '') {
      getCategories().catch((err) => console.error(err));
    }
  }, [actualCountry]);

  return { categories, isLoading };
};

export default usePostsCategories;
